export const SCHEDULE_STATUS = {
    SERVICE_MONTHS_FACTOR : 6,
    STATUS_CONFIRMED : 30,
    STATUS_RESERVED : 10,
    STATUS_IN_PROGRESS : 40,
    STATUS_SCHEDULE_COMPLETED : 60,
    STATUS_CANCELED : 70,
    STATUS_NO_SHOW : 80,
    STATUS_CONFIRMED_OS : 90,
    STATUS_ACHIEVED_BY_PENDENCY : 95,
  }